import React from 'react';
import resumeData from '../data/resumeData.json';

/**
 * @typedef {Object} HeaderSocialLink
 * @property {string} id
 * @property {string} href
 * @property {string} iconClass
 * @property {string} label
 */

/**
 * @typedef {Object} HeaderContactCard
 * @property {string} id
 * @property {string} title
 * @property {string} iconClass
 * @property {string} [value]
 * @property {string[]} [lines]
 * @property {string} [href]
 */

const Header = ({ data = resumeData.header }) => {
  return (
    <section className="o-section o-section--header t-section t-section--header">
      <div className="c-header">
        <div className="o-section__header-bg t-section__header"></div>
        <div className="o-section__content-bg t-section__content"></div>

        <div className="o-container">
          <div className="o-section__container">
            <header className="o-section__header c-header__header t-section__header">
              <div className="c-header__inner-header">
                <div className="c-header__avatar">
                  <div className="a-header c-avatar">
                    <img className="c-avatar__img" src={data.avatarUrl} alt={data.avatarAlt || data.fullName} />
                  </div>
                </div>
              </div>
            </header>

            <div className="o-section__content c-header__content t-section__content">
              <div className="c-header__inner-content">
                <div className="c-header__top">
                  <div className="c-header__brand">
                    <div className="c-brand">
                      <h1 className="c-brand__title t-title">
                        <span className="c-brand__sizer">
                          <span className="a-header c-brand__first-word t-title__first-word">{data.firstName}</span>
                          <span className="a-header c-brand__second-word t-title__second-word">{data.lastName}</span>
                        </span>
                      </h1>
                      <h2 className="a-header c-brand__sub-title t-sub-title">
                        <span className="c-brand__sizer">{data.role}</span>
                      </h2>
                    </div>
                  </div>

                  <ul className="c-header__social-buttons c-social-buttons">
                    {(data.socialLinks || []).map((link) => (
                      <li className="a-header" key={link.id}>
                        <a href={link.href} target="_blank" rel="noopener noreferrer" className="c-social-button t-social-button" aria-label={link.label}>
                          <i className={link.iconClass}></i>
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="c-header__contact">
                  <hr className="a-header c-header__contact-divider" />

                  <div className="o-grid">
                    {(data.contactCards || []).map((card) => (
                      <div className="o-grid__col-md-4 o-grid__col-sm-6" key={card.id}>
                        <div
                          className="a-header o-content"
                          style={{ backgroundColor: '#f9f9f9', padding: '15px', borderRadius: '8px', marginBottom: '10px', textAlign: 'center' }}
                        >
                          <div className="o-content__body">
                            {card.href ? (
                              <a href={card.href} target="_blank" rel="noopener noreferrer" className="t-link-container" style={{ textDecoration: 'none' }}>
                                <h4 style={{ marginBottom: '10px', fontSize: '1.1em', fontWeight: 'bold' }}>
                                  <i className={card.iconClass} style={{ color: '#007bff', marginRight: '8px' }}></i>
                                  {card.title}
                                </h4>
                                <p style={{ color: '#555', margin: 0 }}>
                                  <span className="t-link-container__item--blended" style={{ color: '#007bff' }}>
                                    {card.value}
                                  </span>
                                </p>
                              </a>
                            ) : (
                              <>
                                <h4 style={{ marginBottom: '10px', fontSize: '1.1em', fontWeight: 'bold' }}>
                                  <i className={card.iconClass} style={{ color: '#007bff', marginRight: '8px' }}></i>
                                  {card.title}
                                </h4>
                                {card.lines ? (
                                  <p style={{ color: '#555', margin: 0, lineHeight: '1.6' }}>
                                    {card.lines.map((line) => (
                                      <React.Fragment key={line}>
                                        {line}
                                        <br />
                                      </React.Fragment>
                                    ))}
                                  </p>
                                ) : (
                                  <address style={{ fontStyle: 'normal', color: '#555' }}>{card.value}</address>
                                )}
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Header;
